const LANGUAGES = [
  { code: 'en', locale: 'en-US', label: 'English', flag: '🇺🇸' },
  { code: 'he', locale: 'he-IL', label: 'עברית', flag: '🇮🇱' },
  { code: 'el', locale: 'el-GR', label: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'ru', locale: 'ru-RU', label: 'Русский', flag: '🇷🇺' },
  { code: 'it', locale: 'it-IT', label: 'Italiano', flag: '🇮🇹' },
];

export default LANGUAGES;
